window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "./assets/style/normalize.css";
import "./assets/style/index.css";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import components from "@/components/UI";
import { setupChunkLoadErrorReloadHandlers } from "@/utils/chunkLoadErrorUtils";
import { setupUnauthorizedSessionHandler } from "@/utils/unauthorizedSessionHandler";
import "./registerServiceWorker";

window.updateReady = false;
window.waitingServiceWorker = null;

// Простая функция обновления - принудительная перезагрузка
window.applyUpdate = () => {
  console.log("Force reloading page...");
  // Принудительная перезагрузка с очисткой кэша
  window.location.href =
    window.location.href + "?t=" + new Date().getTime();
};

// Функция для показа уведомления
window.showUpdateNotification = () => {
  console.log("New version available");
};

const pinia = createPinia();
const app = createApp(App);

setupChunkLoadErrorReloadHandlers();

components.forEach((component) => {
  app.component(component.name, component);
});

app.config.errorHandler = (error, instance, info) => {
  console.error("[Vue Error]", error);
  console.error("Component:", instance?.$options?.name);
  console.error("Info:", info);
};

app.config.warnHandler = (msg, instance, trace) => {
  console.warn("[Vue Warn]", msg);
};

app
  .use(Toast, {
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
    position: "top-right",
    toastClassName: "vt_toast_style",
    closeButtonClassName: "vt_close_btn_class",
  })
  .use(pinia)
  .use(router);

setupUnauthorizedSessionHandler(router);

app.mount("#app");
